import { sendStructEvent } from '../../api';

interface PayloadModel {
    eventAction: string;
    eventLabel: string;
    eventProperty: {
        store: number;
        orderID: string;
        userID: number;
        '3dsWarning': boolean;
        paymentMethod: string;
    };
}

export const sendSelectNewPaymentMethodEvent = (payload: PayloadModel): void => {
    const { eventProperty, eventLabel } = payload;

    sendStructEvent({
        eventLabel,
        eventCategory: 'checkout',
        eventAction: 'newPaymentMethod',
        eventProperty,
    });
};
